import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Pill } from '../../../../components-v2/Pill/Pill';
import { Checkbox } from '../../../../components/Checkbox';
import { DataGridRow, DataGridRowItem } from '../../../../components/DataGrid';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../../../components/HoverCard';
import { ROUTES } from '../../../../constants/routes';
import { bs } from '../../../../styles/styles';
import { styleSheet } from './styles';

interface IProps {
	company: Api.ICompany;
	selectionState: Api.ESelectionState;
	selectedCompanyIds: string[];
	excludedCompanyIds: string[];
	onSelectToggle(company: Api.ICompany): void;
}

export const CompanyRow: React.FC<IProps> = props => {
	const { company, selectionState, selectedCompanyIds, excludedCompanyIds, onSelectToggle } = props;
	const [visibleTag, ...extraTags] = company.tagsCollection || [];

	const isSelected = (companyToSelect: Api.ICompany) => {
		if (selectionState === Api.ESelectionState.All || selectionState === Api.ESelectionState.Some) {
			if (selectedCompanyIds.length === 0) {
				// select all checked... only check excluded
				return !excludedCompanyIds.includes(companyToSelect.id);
			}
		}
		return selectedCompanyIds.includes(companyToSelect.id);
	};

	const selected = isSelected(company);
	const domain = !!company.emailDomains && company.emailDomains.length > 0 ? company.emailDomains[0] : '';

	return (
		<DataGridRow>
			<DataGridRowItem styles={[styleSheet.nameColumn, styleSheet.cell]}>
				<Checkbox
					checked={selected}
					id={`company-select-${company.id}`}
					childrenPosition='left'
					backgroundFillColor='white'
					readOnly={true}
					onClick={(e: React.MouseEvent<HTMLInputElement>) => {
						e.stopPropagation();
						e.preventDefault();
						onSelectToggle(company);
					}}
				/>

				<div className={css(bs.flex, bs.flexCol, bs.justifyCenter, bs.truncateText)}>
					<NavLink className={css(styleSheet.companyLink)} to={`${ROUTES.contacts.companies}/${company.id}`}>
						<span className={css(bs.truncateText)}>{company.companyName}</span>
					</NavLink>
				</div>
			</DataGridRowItem>

			<DataGridRowItem styles={[styleSheet.cell]}>
				<div className={css(styleSheet.tagsColumn)}>
					{!!visibleTag && <Pill variant='tag' label={visibleTag.name} color={visibleTag?.color} />}
					{extraTags.length > 0 ? (
						<HoverCard openDelay={0}>
							<HoverCardTrigger className={css(bs.brandLink, styleSheet.tagMore)}>
								&nbsp;{`+${extraTags.length} more`}
							</HoverCardTrigger>
							<HoverCardContent styles={[styleSheet.extraTags]}>
								{extraTags.map(tag => {
									return <Pill variant='tag' key={`${company.id}-${tag.id}`} label={tag.name} color={tag?.color} />;
								})}
							</HoverCardContent>
						</HoverCard>
					) : null}
				</div>
			</DataGridRowItem>

			<DataGridRowItem styles={[styleSheet.cell]}>
				<div className={css(bs.truncateText)}>{domain}</div>
			</DataGridRowItem>
		</DataGridRow>
	);
};
